<script setup lang="ts">
withDefaults(defineProps<{
  text?: string
  location?: 'top' | 'bottom' | 'start' | 'end'
}>(), {
  location: 'top',
})

const show = ref(false)
</script>

<template>
  <div
    class="m-tooltip-wrapper"
    @mouseenter="show = true"
    @mouseleave="show = false"
    @focus="show = true"
    @blur="show = false"
  >
    <slot name="activator" :props="{ onMouseenter: () => show = true, onMouseleave: () => show = false }" />
    <slot />

    <Transition name="m-tooltip">
      <div v-if="show && text" class="m-tooltip" :class="`m-tooltip--${location}`" role="tooltip">
        {{ text }}
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.m-tooltip-wrapper {
  position: relative;
  display: inline-flex;
}

.m-tooltip {
  position: absolute;
  z-index: var(--m-z-tooltip);
  background: #333;
  color: #fff;
  padding: var(--m-space-1) var(--m-space-2);
  border-radius: var(--m-radius-sm);
  font-size: var(--m-font-size-xs);
  white-space: nowrap;
  pointer-events: none;
}

.m-tooltip--top { bottom: 100%; left: 50%; transform: translateX(-50%); margin-bottom: 4px; }
.m-tooltip--bottom { top: 100%; left: 50%; transform: translateX(-50%); margin-top: 4px; }
.m-tooltip--start { right: 100%; top: 50%; transform: translateY(-50%); margin-right: 4px; }
.m-tooltip--end { left: 100%; top: 50%; transform: translateY(-50%); margin-left: 4px; }

.m-tooltip-enter-active,
.m-tooltip-leave-active { transition: opacity var(--m-transition-fast); }
.m-tooltip-enter-from,
.m-tooltip-leave-to { opacity: 0; }
</style>
